import { render, staticRenderFns } from "./ReadyStepLocaleConfig.vue?vue&type=template&id=5d6d1ae9&"
import script from "./ReadyStepLocaleConfig.vue?vue&type=script&lang=js&"
export * from "./ReadyStepLocaleConfig.vue?vue&type=script&lang=js&"
import style0 from "./ReadyStepLocaleConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports